import { quizLegendText } from '~/training/sequence/templates/translators/itemHelpers/Quiz';
import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import {
  ENVELOPE,
  LayoutColumnsDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  QUIZ_CHOICE,
  TEXT,
  LayoutListDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { emailBodyItems } from './itemHelpers/EmailHelper';
import { ItemOfType } from './itemHelpers/types';
import { useEditorStore } from '~/shell/Store';
import { templateTextFieldsEnabled } from '../utils/templateTextFields';
import {
  KICKER_HINT,
  OPTIONAL_TEXT_FIELDS,
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';

export const SocialMedia5: Translator = sequence => {
  const optional = optionalFieldsInEditor(OPTIONAL_TEXT_FIELDS);
  const { contentEditable, editorMode } = useEditorStore.getState();
  // Before the template text fields, the editor left out the question's
  // kicker on a slide with an email.
  const hasEmail = (sequence.items ?? []).some(
    item => item.__typename === 'Email'
  );
  const showsQuestionKicker =
    !hasEmail || !editorMode || templateTextFieldsEnabled();
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Email':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'left',
            overflow: 'visible',
            height: { _: 'auto', lg: '100%' }
          },
          items: [
            {
              type: ENVELOPE,
              id: item.id,
              values: {
                from: 'username@email.com',
                subject: 'Marco’s medical record',
                logo: sequence.personalization
                  ? true
                  : item?.pictures
                    ? item.pictures[0].mediaUrl
                    : null
              },
              items: emailBodyItems(
                item as ItemOfType<'Email'>,
                contentEditable
              )
            }
          ]
        } as LayoutListDefinition);
        break;

      case 'Question':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'left',
            height: { _: 'auto', lg: '100%' },
            padded: true
          },
          items: [
            {
              id: item.id,
              type: LAYOUT_LIST,
              values: { align: 'left' },
              items: [
                ...(showsQuestionKicker && item.items && item.items.length
                  ? [
                      {
                        type: TEXT,
                        id: `${item.id}_subtitle`,
                        items: [],
                        values: {
                          ...optionalFieldValues(
                            optional,
                            'subtitle',
                            KICKER_HINT
                          ),
                          // Edited as saved; learners get 'QUIZ' where it is empty.
                          value: optional.includes('subtitle')
                            ? item.subtitle
                            : item.subtitle || 'QUIZ',
                          variant: 'sub_heading',
                          icon: item.icon
                        }
                      }
                    ]
                  : []),

                {
                  type: TEXT,
                  id: item.id + '_title',
                  items: [],
                  values: {
                    ...optionalFieldValues(optional, 'title'),
                    value: item.title,
                    variant: 'heading1'
                  }
                },
                {
                  type: TEXT,
                  id: item.id + '_body',
                  items: [],
                  values: {
                    ...optionalFieldValues(optional, 'body'),
                    value: item.body
                  }
                },
                {
                  type: QUIZ_CHOICE,
                  id: '1',
                  values: {
                    variant: item.items && item.items.length > 2 ? 'list' : '',
                    title: quizLegendText(item.title, item.body),
                    length: item?.items?.length,
                    multiSelect: item?.items?.filter(
                      item => item.correct === true
                    ).length
                  },
                  items: AnswerButtonHelper({
                    group: item.id,
                    items: item.items,
                    llamaSurvey: item.llamaSurvey,
                    question: item.title || ''
                  })
                }
              ]
            }
          ]
        } as LayoutListDefinition);
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
